import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProjectTypeEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import "../MainCatalogSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';

class EvProjectTypeEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    ept_Input_Description_Multi_Lang: MdsLax<InstanceType<typeof Edit>>;
    ept_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    ept_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);


    }

    protected _onChanged(attribute: string, value: any) {

    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvProjectType2;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProjectTypeEditor);
